import React from 'react'
import { Button, DropdownItem, Icon } from 'gu-ui-kit'
import Dropdown from 'components/Dropdown'
import styles from 'modules/Agency/Clients/subcomponents/PrioritySwitcher/priority-switcher.module.scss'
import PropTypes from 'prop-types'
import PriorityMap from 'modules/Agency/Clients/subcomponents/PrioritySwitcher/priorityMap'
import { useTranslation } from 'react-i18next'

const PrioritySwitcher = ({ onChange, priority }) => {
  const { t } = useTranslation()

  return (
    <Dropdown
      id={'PrioritySwitcherPopover'}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 5,
        horizontal: -10,
      }}
      ButtonComponent={() => (
        <Button
          noLabel
          startIcon={<Icon name={'flag'} />}
          bgColorHover={'none'}
          bgColorActive={'none'}
          bgColor={'none'}
          color={PriorityMap[priority]}
          size={'m'}
        />
      )}
    >
      {Object.keys(PriorityMap).map((key) => (
        <DropdownItem
          key={'priority-' + key}
          className={styles['item']}
          startIcon={<Icon name={'flag'} size={'m'} color={PriorityMap[key]} />}
          onClick={() => onChange(key)}
        >
          {t('agency::clients.priority.' + key)}
        </DropdownItem>
      ))}
    </Dropdown>
  )
}

export default PrioritySwitcher

PrioritySwitcher.propTypes = {
  onChange: PropTypes.func.isRequired,
  priority: PropTypes.string.isRequired,
}
